/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { VueConstructor } from 'vue';

import AdditionalText from '@/pages/survey/components/fields/AdditionalText.vue';
import Checkbox from '@/pages/survey/components/fields/Checkbox.vue';
import Date from '@/pages/survey/components/fields/Date.vue';
import DateTime from '@/pages/survey/components/fields/DateTime.vue';
import Email from '@/pages/survey/components/fields/Email.vue';
import File from '@/pages/survey/components/fields/File.vue';
import Radio from '@/pages/survey/components/fields/Radio.vue';
import TextLong from '@/pages/survey/components/fields/TextLong.vue';
import TextShort from '@/pages/survey/components/fields/TextShort.vue';
import Url from '@/pages/survey/components/fields/Url.vue';

import { ApiQuestionType } from '../types';

/* eslint-disable camelcase */
const questionComponents: { [key: string]: VueConstructor } = {
  additional_text: AdditionalText,
  checkboxes: Checkbox,
  date: Date,
  datetime: DateTime,
  email: Email,
  file_upload: File,
  radio: Radio,
  rich_text: TextLong,
  text_field: TextShort,
  url: Url,
} as { [T in ApiQuestionType]: VueConstructor };
/* eslint-enable camelcase */

export default questionComponents;
